export default {
	namespaced: true,
	state: () => ({
		rpcUrl:"https://nyc.shield.fogo.testnet.fluxrpc.com?key=B5uP49XccWKb_BXHc4_u9A",
	}),
	mutations: {
		//
	}
}
